const COLOR_MAP = {
  "glp-1-research": ["#3B82F6", "#1E3A8A"],
  "healing-recovery-research": ["#5D9CCC", "#1D4ED8"],
  "growth-hormone-research": ["#3B82F6", "#1E40AF"],
  "cellular-longevity-research": ["#60A5FA", "#1E3A8A"],
};

export default function ProductVial({ categorySlug, name, strength, className = "" }) {
  const [colorA, colorB] = COLOR_MAP[categorySlug] || ["#3B82F6", "#1E3A8A"];
  const uid = (name || "x").replace(/\s+/g, "");

  return (
    <svg viewBox="0 0 160 220" className={`drop-shadow-[0_18px_30px_rgba(37,99,235,0.18)] ${className}`} data-testid="product-vial-graphic">
      <defs>
        <linearGradient id={`glassGrad-${uid}`} x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#FFFFFF" />
          <stop offset="55%" stopColor="#F1F5F9" />
          <stop offset="100%" stopColor="#E2E8F0" />
        </linearGradient>
        <linearGradient id={`liquidGrad-${uid}`} x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stopColor={colorA} stopOpacity="0.9" />
          <stop offset="100%" stopColor={colorB} stopOpacity="0.98" />
        </linearGradient>
        <linearGradient id={`capGrad-${uid}`} x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stopColor={colorA} />
          <stop offset="100%" stopColor={colorB} />
        </linearGradient>
        <radialGradient id={`glow-${uid}`} cx="50%" cy="55%" r="60%">
          <stop offset="0%" stopColor={colorA} stopOpacity="0.25" />
          <stop offset="100%" stopColor={colorA} stopOpacity="0" />
        </radialGradient>
        <linearGradient id={`shine-${uid}`} x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="#FFFFFF" stopOpacity="0.7" />
          <stop offset="100%" stopColor="#FFFFFF" stopOpacity="0" />
        </linearGradient>
      </defs>

      {/* ambient glow behind vial */}
      <ellipse cx="80" cy="130" rx="70" ry="90" fill={`url(#glow-${uid})`} />

      {/* cap */}
      <rect x="58" y="8" width="44" height="20" rx="4" fill={`url(#capGrad-${uid})`} />
      <rect x="53" y="26" width="54" height="11" rx="4" fill="#CBD5E1" />

      {/* vial body (glass) */}
      <rect x="34" y="37" width="92" height="162" rx="16" fill={`url(#glassGrad-${uid})`} stroke="#CBD5E1" strokeWidth="1.5" />

      {/* liquid fill */}
      <path d="M40 122 Q80 112 120 122 V193 Q120 197 116 197 H44 Q40 197 40 193 Z" fill={`url(#liquidGrad-${uid})`} />

      {/* glass shine streak */}
      <rect x="42" y="44" width="10" height="148" rx="5" fill={`url(#shine-${uid})`} />

      {/* label */}
      <rect x="42" y="72" width="76" height="44" rx="5" fill="white" stroke="#DBEAFE" strokeWidth="1.2" />
      <text x="80" y="90" textAnchor="middle" fontSize="9" fontWeight="700" fill="#0F172A" fontFamily="Manrope, sans-serif">
        {(name || "").slice(0, 14).toUpperCase()}
      </text>
      <text x="80" y="101" textAnchor="middle" fontSize="7" fill="#475569" fontFamily="IBM Plex Sans, sans-serif">
        {strength}
      </text>
      <text x="80" y="111" textAnchor="middle" fontSize="5.5" fill={colorB} letterSpacing="0.8" fontFamily="IBM Plex Sans, sans-serif" fontWeight="600">
        RESEARCH USE ONLY
      </text>
    </svg>
  );
}
